import { Button } from "@mui/material";
import React from "react";
import { useState } from "react";
import InviteMemberDialog from "./InviteMemberDialog";
import AddIcon from "@mui/icons-material/Add";

export default function InviteMemberButton({ boardId }: { boardId: string }) {
    const [open, setOpen] = useState(false);

    return (
        <>
            <Button
                variant="contained"
                onClick={() => setOpen(true)}
                startIcon={<AddIcon />}
            >
                Invite Member
            </Button>

            <InviteMemberDialog
                boardId={boardId}
                open={open}
                onClose={() => setOpen(false)}
            />
        </>
    );
}